<style src="./ButtonToggle.scss" lang="scss" scoped></style>
<template>
  <fieldset class="button-toggle">
    <button
      type="button"
      class="btn-small-ghost color-danger"
      @click="changeValue(true)"
      v-if="buttonState === true">
      {{ deactiveLabel }}
    </button>

    <button
      type="button"
      class="btn-small-primary"
      @click="changeValue(false)"
      v-if="buttonState === false">
      {{ activeLabel }}
    </button>
  </fieldset>
</template>

<script>
export default {
  name: 'ButtonToggle',
  props: {
    value: {
      default: true
    },
    activeLabel: {
      default: 'Ativar'
    },
    deactiveLabel: {
      default: 'Desativar'
    }
  },
  data () {
    return {
      buttonState: true
    }
  },
  watch: {
    'value' (pValue) {
      this.buttonState = pValue
    },
    buttonState (pValue) {
      this.$emit('input', pValue)
      this.$emit('changed-value', pValue)
    }
  },
  methods: {
    changeValue (pValue) {
      this.buttonState = !pValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/button-toggle/ButtonToggle.vue